<!------------------------------------------------------------------------------
 File: TrafficModule 
 Created by keni.
 with: IntelliJ IDEA
 Date: 03/07/2018
 Time: 12:38
------------------------------------------------------------------------------->
<template>
    <section class="">
<!--<h1>Traffic</h1>-->
    </section>
</template>

<script>
	export default {
		name: "traffic-module",
		components: {},
		props: {
		},
		created() {
		},
		destroyed() {
		},
		mounted() {
		},
		data() {
			return {

			}
		},
		methods: {},
		watch: {

		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/TrafficModule.vue?1cb8ffa5